import * as t from 'io-ts';
import { defineStore } from 'pinia';
import { computed, ref } from 'vue';

export const AllPermissionsC = t.record(t.string, t.string);

export const UserPermissionsC = t.array(t.string);

export const ResponsePermissionsC = t.type({
    all: AllPermissionsC,
    user: UserPermissionsC,
});

export type PermissionsResponse = t.TypeOf<typeof ResponsePermissionsC>;

export type AllPermissions = t.TypeOf<typeof AllPermissionsC>;

export const usePermissionsStore = defineStore('permissions', () => {
    const baseAllPermissions = ref<AllPermissions | null>(null);

    const allPermissions = computed<AllPermissions>(() => baseAllPermissions.value ?? {});

    const areAllPermissionsSet = computed(() => baseAllPermissions.value !== null);

    const setAllPermissions = (permissions: AllPermissions) => {
        baseAllPermissions.value = permissions;
    };

    return {
        allPermissions,
        areAllPermissionsSet,
        setAllPermissions,
    };
});
